import { axiosInstance } from '../request';
export const registerDevice = async (payload) => {
    await axiosInstance.post('/api/v1/devices', payload);
};
export const deleteDevice = async (token) => {
    await axiosInstance.delete(`/api/v1/devices/${encodeURIComponent(token)}`);
};
//# sourceMappingURL=devices.api.js.map